/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */
import { Component, ViewEncapsulation, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { OutagesResponse, OutagesBasicInfo } from '../model/outagesresponse';
import { OutagesFilterInfo } from '../model/outagesfilterinfo';
import { OutagesService } from '../services/outages.service';
import { ActivatedRoute } from '@angular/router';
import { ZSDTranslateService } from '../../../../common/zsd-translate.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BannerComponent } from '../../../../customer/view/banner/banner.component';
import { SpinnerService } from '../../../../shared/spinner/spinner.service';
import { CustomerPreferenceService } from '../../../../customer/preference/customerpreference.service';
import { CustomerPreferenceResponse } from '../../../../customer/preference/customerpreference.model';
declare var $: any;

@Component({
    selector: 'zsd-currentoutages',
    templateUrl: '../view/cur-outageslist.component.html',
    styleUrls: ['../view/cur-outageslist.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CurrentOutagesComponent implements  OnInit {
    outagesResultsCount = 0;
    outagesPerPage = 20;
    page = 0;
    sortBy = 'itemName';
    sortOrder = 'DESC';
    isLoading = false;
    maxNoOfItems: Number;
    isOutageslist;
    scrollEndReached = false;
    isDesc = false;
    column: string;
    plannedOutagesResultCount: number;
    canCusotmerViewPlannedOutages: boolean;

    outagesBasicInfoResponse = new Array<OutagesBasicInfo>();
    outagesListResponse: OutagesResponse = new OutagesResponse();
    outagesFilterInfo: OutagesFilterInfo = new OutagesFilterInfo();
    plannedOutagesFilterInfo: OutagesFilterInfo = new OutagesFilterInfo();
    spinnerStart = true; // adding for showing spinner while loading instead of No request message

    @Output() openfilter = new EventEmitter<boolean>();

    constructor(public outagesService: OutagesService, private route: ActivatedRoute,
        public zsdTranslate: ZSDTranslateService, public http: HttpClient,
        public spinnerService: SpinnerService, private custpreferences: CustomerPreferenceService) {
    }

   ngOnInit() {
    this.custpreferences.getPreferenceList().toPromise()
    .then(
        (customerpreferenceResponse: CustomerPreferenceResponse) => {
            this.canCusotmerViewPlannedOutages = customerpreferenceResponse.canCusotmerViewPlannedOutages;
            if (this.canCusotmerViewPlannedOutages) {
                   this.initPlannedOutagesListCount();
               }
        }
    );
        /* To refresh Global search dropdown */
    BannerComponent.refreshGlobalSearchDropdown.next(false);
    this.sort('itemName');
   }

   sort(property: string) {
    this.initializeItemsParameters();
    $('#property').removeClass('fa fa-sort');
    this.isDesc = !this.isDesc;
    this.column = property;
    if (this.isDesc === true) {
        this.sortOrder = 'ASC';
    } else {
        this.sortOrder = 'DESC';
    }
    this.sortBy = property;

    this.initFilter();
    this.applyFilterParamaeter(this.outagesFilterInfo);
    this.isLoading = true;
    this.spinnerService.show();
   }

   applyFilterParamaeter(outagesFilterInfo: OutagesFilterInfo) {

    if (outagesFilterInfo) {
        this.getCurrentOutagesList(this.page, this.sortBy, this.sortOrder, outagesFilterInfo);
    } else {
        outagesFilterInfo.searchTerm = '';
        outagesFilterInfo.categoryIds = [];
        outagesFilterInfo.itemTypeIds = [];
        this.getCurrentOutagesList(this.page, this.sortBy, this.sortOrder, outagesFilterInfo);

    }

   }

   initFilter() {
       let categoryIds = new Array<number>();
       let itemTypeIds = new Array<number>();

       this.route.queryParams.subscribe(params => {
        if (params[ 'searchTerm' ]) {
            this.outagesFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
        }
        if (params[ 'categoryIds']) {
         categoryIds  = JSON.parse(params['categoryIds']);
        }
        if (params['itemTypeIds']) {
           itemTypeIds = JSON.parse(params['itemTypeIds']);
        }
        this.outagesFilterInfo.categoryIds = categoryIds;
        this.outagesFilterInfo.itemTypeIds = itemTypeIds;
       });
   }
    getCurrentOutagesList(pageNo: number, sortBy: string, sortOrder: string, outagesFilterInfo: OutagesFilterInfo) {
        let params = new HttpParams()
            .set('offset', this.page.toString())
            .set('limit', this.outagesPerPage.toString())
            .set('sortBy', this.sortBy)
            .set('sortOrder', this.sortOrder);

        if (outagesFilterInfo.itemTypeIds) {
            for (let i = 0; i < outagesFilterInfo.itemTypeIds.length; i++) {
                params = params.append('itemTypeId', outagesFilterInfo.itemTypeIds[i].toString());
            }
        }
        if (outagesFilterInfo.categoryIds) {
            for (let i = 0; i < outagesFilterInfo.categoryIds.length; i++) {
                params = params.append('itemCategoryId', outagesFilterInfo.categoryIds[i].toString());
            }
        }
        if (outagesFilterInfo.searchTerm !== null && outagesFilterInfo.searchTerm) {
            params = params.append('searchTerm', outagesFilterInfo.searchTerm);
        }
        if (!this.isLoading) {
            this.isLoading = true;
            this.spinnerService.show();
            if (pageNo === -1) {
                this.isLoading = true;
                this.spinnerService.show();
                this.page = 0;
                this.sortBy = sortBy;
                this.sortOrder = sortOrder;
                this.initializeItemsParameters();
                pageNo = 0;
            }

            this.outagesService.getOutagesList(params)
                .subscribe(
                    (outagesResponse: OutagesResponse) => {
                        this.maxNoOfItems = outagesResponse.resultCount;
                        if (this.maxNoOfItems > 0) {
                            this.isOutageslist = true;
                            this.scrollEndReached = false;
                        }
                        this.outagesBasicInfoResponse = this.outagesBasicInfoResponse.concat(
                            outagesResponse.results
                        );
                        this.page++;
                        if (this.outagesBasicInfoResponse.length >= this.maxNoOfItems) {
                            this.scrollEndReached = true;
                        }
                        this.isLoading = false;
                        this.spinnerStart = false;

                    },
                    err => {
                        console.error(err.error);
                        this.isOutageslist = false;
                        this.isLoading = false;
                        this.spinnerStart = false;
                    }
                );
        }
    }
    initPlannedOutagesListCount() {
        let params = new HttpParams()
                .set('offset', '0')
                .set('limit', '1');
        this.outagesService.getPlannedOutagesList(params, this.plannedOutagesFilterInfo).subscribe();
    }
    scrollEnd() {
        if (!this.scrollEndReached) {
          this.initFilter();
          this.getCurrentOutagesList(this.page, this.sortBy, this.sortOrder, this.outagesFilterInfo);
        }
      }
      scrollCur() {
      }

      trackByOutages(index) {
        return index;
      }
      @HostListener('window:beforeunload', ['$event']) unloadHandler() {
        new CurrentOutagesComponent(
            this.outagesService,
            this.route,  this.zsdTranslate,  this.http,
            this.spinnerService, this.custpreferences );
        window.scrollTo(0, 0);
      }
    initializeItemsParameters() {
        this.isLoading = false;
        this.page = 0;
        this.isOutageslist = false;
        this.outagesBasicInfoResponse = [];
        this.outagesFilterInfo = new OutagesFilterInfo();
        this.outagesListResponse = new OutagesResponse();
    }
    openFilter() {
        this.openfilter.emit(true);
    }

    getRouterPath(outageItem: OutagesBasicInfo): string {
        if (outageItem.isServiceItem) {
            return 'sitem/' + outageItem.itemId;
        } else {
            return 'item/' + outageItem.itemId;
        }
    }

}
